/**
 * The US ticket's sounds, on the channels the Kalshi ticket already uses and
 * within the trader's alert preferences (each channel's switch and volume).
 * No new channel: the placed chirp means Polymarket US has the order; the
 * rejected descent means the click placed nothing (a refusal, an aborted or
 * rejected receipt, or a guard that kept the original). An unconfirmed result
 * plays nothing: it is not "not placed", and its amber line says to check.
 */
import { getChannelVolume, isChannelSoundEnabled } from '@/lib/alerts/alertPreferences';
import { playOrderPlacedTone, playOrderRejectedTone } from '@/lib/audio/tradeAudio';

export function playUsPlacedTone(): void {
  if (isChannelSoundEnabled('orderPlaced')) playOrderPlacedTone(getChannelVolume('orderPlaced'));
}

export function playUsRejectedTone(): void {
  if (isChannelSoundEnabled('orderRejected')) playOrderRejectedTone(getChannelVolume('orderRejected'));
}
